import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Layout from "../Componants/Layout";
import { Col, Container, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import useVendorDetails from "../hooks/VendorDetails";
import { useMutation } from "@tanstack/react-query";
import { putRequest } from "../services/apiMethods";
import toast from "react-hot-toast";
import ConfirmModal from "../Modal/ConfirmModal";
import EmailverifyModal from "../Modal/EmailverifyModal";
import ConfirmPassword from "../Modal/ConfirmPassword";

export default function AccountDetails() {
  const location = useLocation();
  const { data: loginUserDetail, isLoading, refresh } = useVendorDetails();
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedType, setSelectedType] = useState("");
  const [updatedEmail, setUpdatedEmail] = useState("");
  const [show, setShow] = useState(false);
  const [passwordshow, setPasswordshow] = useState(false);

  const handlePasswordConfirm = (type) => {
    setPasswordshow(true);
    setSelectedType(type);
  };

  const handlePasswordClose = async () => {
    setPasswordshow(false);
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  const handleDelete = (type) => {
    setModalOpen(true);
    setSelectedType(type);
  };

  const handleConfirmClose = async () => {
    setModalOpen(false);
  };


  const navigate = useNavigate();

  const initialData = {
    name: "",
    email: "",
  };




  const { mutate, isLoading: apiState } = useMutation({
    mutationFn: (data) => {
      const modifyData = {
        email: data?.email || "",
        name: data?.name || "",
      }
      return putRequest(`/profile/edit`, modifyData);
    },
    onSuccess: (data) => {
      if (data?.data?.updatedEmail && data?.data?.updatedEmail !== loginUserDetail?.email) {
        handleShow()
        setUpdatedEmail(data?.data?.updatedEmail)
      } else {
        toast.success(`${data?.message}`, {
          iconTheme: {
            primary: '#337FE0',
            secondary: '#FFFAEE',
          },
        })
        navigate(-1)
      }

    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });



  // Formik initial values and validation schema
  const formik = useFormik({
    initialValues: loginUserDetail || initialData, // Correctly set initial values
    enableReinitialize: true,
    validationSchema: Yup.object({
      name: Yup.string()
        .min(2, "Name must be at least 2 characters")
        .required("Name is required"),
      email: Yup.string()
        .email("Invalid email format")
        .required("Email is required"),
    }),
    onSubmit: (values) => {
      mutate(values);
    },
  });

  return (
    <>
      <Layout>
        <Container>
          <div className="dashboard-main">
            <h3
              className="with-back-btn cursor-pointer"
              onClick={() => navigate("/settings")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M4 12L3.29289 11.2929L2.58579 12L3.29289 12.7071L4 12ZM19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11V13ZM9.29289 5.29289L3.29289 11.2929L4.70711 12.7071L10.7071 6.70711L9.29289 5.29289ZM3.29289 12.7071L9.29289 18.7071L10.7071 17.2929L4.70711 11.2929L3.29289 12.7071ZM4 13H19V11H4V13Z"
                  fill="black"
                />
              </svg>
              Account
            </h3>
            <Row>
              <Col lg={8}>
                <div className="my-profile-card-contain">
                  <div className="my-profile-title">
                    <h4>Account Details</h4>
                  </div>
                  <div className="my-profile-box-contain">
                    <div className="my-profile-box-form">
                      <div className="form-box-title">
                        <h4>Personal Details</h4>
                        <p>Update your personal details.</p>
                      </div>
                      <div className="h-100 m-0">
                        <Form
                          className="cmn-form-set"
                          onSubmit={formik.handleSubmit}
                        >
                          <Form.Group
                            className="mb-3"
                            controlId="formFirstName"
                          >
                            <Form.Label>Account Holder Name</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Type here"
                              name="name"
                              value={formik.values.name}
                              onChange={(e) => {
                                let value = e.target.value.replace(/^\s+/, ""); // Remove leading spaces
                                value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                                formik?.setFieldValue("name", value);
                              }}
                              onBlur={formik.handleBlur}
                              isInvalid={
                                formik.touched.name && !!formik.errors.name
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              {formik.errors.name}
                            </Form.Control.Feedback>
                          </Form.Group>

                          <Form.Group className="mb-3" controlId="formEmail">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                              type="email"
                              placeholder="Type here"
                              name="email"
                              value={formik.values.email}
                              onChange={formik.handleChange}

                              onBlur={formik.handleBlur}
                              isInvalid={
                                formik.touched.email && !!formik.errors.email
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              {formik.errors.email}
                            </Form.Control.Feedback>
                          </Form.Group>
                          <div className="d-flex gap-4">
                            <button
                              type="submit"
                              className="theme-comm-btn"
                            >
                              Update
                            </button>
                          </div>
                        </Form>
                      </div>
                    </div>
                    <div className="my-profile-box-form">
                      <div className="form-box-title">
                        <h4>Looking to Leave?</h4>
                        <p>Request to delete your account from here.</p>
                      </div>
                      <div className="h-100 m-0">
                        <div className="d-flex gap-4">
                          <button className="theme-red-comm-btn"

                            // onClick={()=>handleDelete("vendorDelete")}

                            onClick={() => handlePasswordConfirm("customerDelete")}
                          >
                            Delete Account
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={4}></Col>
            </Row>
          </div>
        </Container>
        <ConfirmModal
          data={location.search}
          isModalOpen={isModalOpen}
          selectedType={selectedType}
          handleConfirmClose={handleConfirmClose}
        />
        <EmailverifyModal
          show={show}
          handleClose={handleClose}
          refresh={refresh}
          updatedEmail={updatedEmail}
        />


        <ConfirmPassword
          passwordshow={passwordshow}
          handlePasswordClose={handlePasswordClose}
          handleDelete={handleDelete}
          type={"vendorDelete"}
        />
      </Layout>
    </>
  );
}
